<template>
  <div class="space-y-3">
    <button v-if="show.length == 0 || show.indexOf('mailup') > -1" @click="socialAuth('mailup') & signMailup()" type="button" class="flex items-center w-full justify-center text-gray-600 hover:text-gray-700 rounded shadow-md hover:bg-gray-50 border border-gray-200 transition relative hover:border-gray-300 focus:border-gray-300 focus:ring-gray-300 focus:outline-none focus:ring">
      <div class="w-4/12 lg:w-5/12 flex flex-row justify-evenly items-center">
        <img src="https://setup.baymark.net/storage/channels/images/channel_2_short.png" alt="mailup" class="h-8 w-8" />
        <span class="px-0 py-3 flex-1 text-center font-semibold">{{ t("signin_mailup") }}</span>
      </div>
      <Spinner v-if="signWithMailup" size="small" color="green" class="absolute right-0 mr-3" />
    </button>
    <button v-if="show.length == 0 || show.indexOf('google') > -1" @click="socialAuth('google') & signGoogle()" type="button" class="flex items-center w-full justify-center text-gray-600 rounded shadow-md hover:bg-gray-50 border border-gray-200 transition relative focus:border-gray-300 focus:ring-gray-200 focus:outline-none focus:ring">
      <div class="w-4/12 lg:w-5/12 flex flex-row justify-evenly items-center">
        <svg class="h-6 w-6" viewBox="0 0 40 40">
          <path d="M36.3425 16.7358H35V16.6667H20V23.3333H29.4192C28.045 27.2142 24.3525 30 20 30C14.4775 30 10 25.5225 10 20C10 14.4775 14.4775 9.99999 20 9.99999C22.5492 9.99999 24.8683 10.9617 26.6342 12.5325L31.3483 7.81833C28.3717 5.04416 24.39 3.33333 20 3.33333C10.7958 3.33333 3.33335 10.7958 3.33335 20C3.33335 29.2042 10.7958 36.6667 20 36.6667C29.2042 36.6667 36.6667 29.2042 36.6667 20C36.6667 18.8825 36.5517 17.7917 36.3425 16.7358Z" fill="#FFC107" />
          <path d="M5.25497 12.2425L10.7308 16.2583C12.2125 12.59 15.8008 9.99999 20 9.99999C22.5491 9.99999 24.8683 10.9617 26.6341 12.5325L31.3483 7.81833C28.3716 5.04416 24.39 3.33333 20 3.33333C13.5983 3.33333 8.04663 6.94749 5.25497 12.2425Z" fill="#FF3D00" />
          <path d="M20 36.6667C24.305 36.6667 28.2167 35.0192 31.1742 32.34L26.0159 27.975C24.3425 29.2425 22.2625 30 20 30C15.665 30 11.9842 27.2359 10.5975 23.3784L5.16254 27.5659C7.92087 32.9634 13.5225 36.6667 20 36.6667Z" fill="#4CAF50" />
          <path d="M36.3425 16.7358H35V16.6667H20V23.3333H29.4192C28.7592 25.1975 27.56 26.805 26.0133 27.9758C26.0142 27.975 26.015 27.975 26.0158 27.9742L31.1742 32.3392C30.8092 32.6708 36.6667 28.3333 36.6667 20C36.6667 18.8825 36.5517 17.7917 36.3425 16.7358Z" fill="#1976D2" />
        </svg>
        <span class="px-0 py-3 flex-1 text-center font-semibold">{{ t("signin_google", {}, { locale: $store.state.Langs.selected.lang }) }}</span>
      </div>
      <Spinner v-if="signWithGoogle" size="small" color="green" class="absolute right-0 mr-3" />
    </button>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n"
import Spinner from "@/components/UI/Spinner"
export default {
  name: "SocialLogin",
  components: {
    Spinner
  },
  props: {
    show: {
      type: Array,
      default: function () {
        return []
      }
    },
    paramsExtra: {
      type: String,
      default: ""
    },
    urlRedirect: {
      type: String,
      default: `${process.env.VUE_APP_URL}/login`
    },
    mailupText: {
      type: String
    }
  },
  data: function () {
    return {
      lang: "",
      signWithMailup: false,
      signWithGoogle: false
    }
  },
  created() {
    this.lang = localStorage.getItem("Lang")
  },
  setup() {
    const { t, locale } = useI18n()
    return { t, locale }
  },
  methods: {
    socialAuth: function (provider) {
      window.location.href = `${process.env.VUE_APP_URL_API}/auth/redirect/${provider}?${this.paramsExtra}&return=${this.urlRedirect}`
    },
    signMailup: function () {
      this.signWithMailup = true
    },
    signGoogle: function () {
      this.signWithGoogle = true
    }
  }
}
</script>
